export default "__VITE_ASSET__D3GfyLj0__"